import React from "react";
import MediaQuery from "react-responsive";

const VisibleOn = ({ children, width }) => (
  <MediaQuery maxWidth={width}>{children}</MediaQuery>
);

VisibleOn.displayName = "VisibleOn";

export default VisibleOn;
